import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — the church spire: a tall pointed steeple on a 0.8 m square
// stone base, a shaft, and a steep four-sided spire rising to 4.5 m, topped
// with a small cross. Sits on the ground within one tile; stack it beside
// or on top of a tower of wall tiles.
const STONE = "#c9c2b6";
const STONE_DARK = "#b8b2a8";
const SPIRE = "#4a4a4e";
const BLACK = "#2e2e30";

const BASE_H = 0.7;
const SHAFT_H = 1.5;
const SPIRE_TOP = 4.5;
const SPIRE_H = SPIRE_TOP - (BASE_H + SHAFT_H);
// Four-sided cone rotated 45 degrees so its faces align with the tile axes;
// the radius circumscribes the square footprint below it.
const SQ = Math.PI / 4;

export const churchSpire = defineModel({
  id: "church-spire",
  batchId: "modern",
  name: "Church spire",
  tags: ["modern", "outdoor", "structure", "roof", "church", "spire"],
  summary: "A tall pointed steeple with a cross, rising to 4.5 m.",
  description:
    "The steeple of the Modern Living kit: a 0.8 m square stone base and " +
    "shaft carrying a steep dark-grey pyramidal spire to 4.5 m, topped by a " +
    "small cross. One tile; suits churches and chapels.",
  tiles: { w: 1, h: 1 },
  footprint: 2.4,
  parts(): Part[] {
    return [
      // Square stone base and shaft with a cornice band between spire and shaft.
      { geometry: new THREE.BoxGeometry(0.8, BASE_H, 0.8), color: STONE_DARK, position: [0, BASE_H / 2, 0] },
      { geometry: new THREE.BoxGeometry(0.64, SHAFT_H, 0.64), color: STONE,
        position: [0, BASE_H + SHAFT_H / 2, 0] },
      { geometry: new THREE.BoxGeometry(0.76, 0.1, 0.76), color: STONE_DARK,
        position: [0, BASE_H + SHAFT_H - 0.05, 0] },
      // The spire: a four-sided pyramid, faces aligned with the shaft.
      { geometry: new THREE.ConeGeometry(0.38 * Math.SQRT2, SPIRE_H, 4), color: SPIRE,
        position: [0, BASE_H + SHAFT_H + SPIRE_H / 2, 0], rotation: [0, SQ, 0] },
      // The cross: two thin boxes above the tip.
      { geometry: new THREE.BoxGeometry(0.04, 0.42, 0.04), color: BLACK, position: [0, SPIRE_TOP + 0.18, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.04, 0.04), color: BLACK, position: [0, SPIRE_TOP + 0.26, 0] },
    ];
  },
  animations: [],
});
